
class ErrorWithDetails extends Error {
    constructor(message, details) {
        super(message);
        this.name = this.constructor.name;
        this.details = details;
    }
}
class PlanNotFound extends ErrorWithDetails {}
class AttachmentNotFound extends ErrorWithDetails {}

export default ErrorWithDetails;
export { PlanNotFound, AttachmentNotFound };
